import React from 'react';

import { useApolloClient } from '@apollo/client';
import { useRouter } from 'expo-router';
import { useStoreContext } from 'features/store';
import { View } from 'react-native';

import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import useEffectOnce from 'hooks/use-effect-once';
import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';
import { useAuthContext } from 'state/auth';
import { useInRestaurantRedemptionContext } from 'state/loyalty/in-restaurant-redemption';
import { useServiceModeContext } from 'state/service-mode';
import logger from 'utils/logger';
import { routes } from 'utils/routing';

function SignOut() {
  const client = useApolloClient();
  const { resetStore } = useStoreContext();
  const { selectServiceMode } = useServiceModeContext();
  const { resetInRestaurantRedemption } = useInRestaurantRedemptionContext();
  const { setOriginLocation, signOut } = useAuthContext();

  const router = useRouter();

  useRumPageView('sign-out', 'Sign Out');

  useEffectOnce(() => {
    signOut()
      .finally(() => {
        resetStore();
        resetInRestaurantRedemption();
        selectServiceMode(null);
        setOriginLocation(null);
        client.resetStore();
        router.replace(routes.base);
      })
      .catch(error => {
        logger.error({ message: 'An error occurred signing out - SignOut page', error });
      });
  });

  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LoyaltyLoader />
    </View>
  );
}

export default SignOut;
